import { atom } from 'recoil';

// Sidebar state types
export type SideBarState = 'home' | 'saved' | 'addPlace' | 'filter' | 'notifications' | 'planRoute' | null;

// Atom for sidebar state
export const sideBarStateAtom = atom<SideBarState>({
    key: 'sideBarState',
    default: null,
});
